export default "/images/e0e4bc5add32dbf19c57445c6d624ae8.avif";